export default __webpack_public_path__ + "static/Text-alternatives-DO_5-446cb4802ae88d067206cc022ca8431d.png";